import { all, takeEvery } from "redux-saga/effects";
import { actionTypes as marketingPartnersActionTypes } from "./reducer";
import {
  getMarketingPartners as getMarketingPartnersService,
  postMarketingPartners as postMarketingPartnersService,
  getMaintainedValues as getMaintainedValuesService,
  searchMarket as searchMarketService,
  saveReason as saveReasonService,
} from "./service";
import processAction from "../../../../utils/processAction";

function* getMarketingPartners(action) {
  yield processAction({
    ...action,
    service: getMarketingPartnersService,
    success: marketingPartnersActionTypes.GET_MARKETING_PARTNERS_SUCCESS,
    failed: marketingPartnersActionTypes.GET_MARKETING_PARTNERS_FAILED
  });
}

function* postMarketingPartners(action) {
  yield processAction({
    ...action,
    service: postMarketingPartnersService,
    success: marketingPartnersActionTypes.POST_MARKETING_PARTNERS_SUCCESS,
    failed: marketingPartnersActionTypes.POST_MARKETING_PARTNERS_FAILED
  });
}

function* searchForMarket(action) {
  yield processAction({
    ...action,
    service: searchMarketService,
    success: marketingPartnersActionTypes.MARKET_SEARCH_SUCCESS,
    failed: marketingPartnersActionTypes.MARKET_SEARCH_FAILED
  });
}

function* saveAppeal(action) {
  yield processAction({
    ...action,
    service: saveReasonService,
    success: marketingPartnersActionTypes.SAVE_REASON_SUCCESS,
    failed: marketingPartnersActionTypes.SAVE_REASON_FAILED
  });
}

function* getMaintainedValues(action) {
  yield processAction({
    ...action,
    service: getMaintainedValuesService,
    success: marketingPartnersActionTypes.GET_MAINTAINED_VALUES_SUCCESS,
    failed: marketingPartnersActionTypes.GET_MAINTAINED_VALUES_FAILED
  });
}

function* watcher() {
  yield all([
    takeEvery(
      marketingPartnersActionTypes.GET_MARKETING_PARTNERS,
      getMarketingPartners
    ),
    takeEvery(
      marketingPartnersActionTypes.POST_MARKETING_PARTNERS,
      postMarketingPartners
    ),
    takeEvery(marketingPartnersActionTypes.MARKET_SEARCH,
      searchForMarket),

    takeEvery(marketingPartnersActionTypes.SAVE_REASON,
      saveAppeal),

    takeEvery(
      marketingPartnersActionTypes.GET_MAINTAINED_VALUES,
      getMaintainedValues
    )
  ]);
}

export default [watcher()];
